import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { TaskCreateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { EnumToComboValues, GridColumnHelper } from '../utils';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';
import { TaskDetailsSectionHandler } from './details.section';
import { Observable, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { NamedTaskResponse } from './model';


@RegisterEntityHandler('task')
@Injectable()
export class TaskHandler extends EntityHandler<NamedTaskResponse> {

    constructor(
        admin: AdminEditorService
    ) {
        super(admin);
    }

    states = ['pending', 'executing', 'waiting', 'success', 'canceling', 'canceled', 'failed', 'timedout', 'deferred'];
    items: EntityListResult;

    async listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        this.items = await this.admin.getCached(`listTasks/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.tasks.listTasks(ownerId, offset, limit, sort, filter), 3).then(response => ({
            ...response,
            type: 'task',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.TASKS'),
        }));
        return this.items;
    }

    getEntity(id: string): Observable<NamedTaskResponse> {
         return timer(0, 5000).pipe( // poll the backend every 5 seconds
             switchMap(() => this.admin.getCached(`getTask/${id}`, api => api.tasks.getTask(id).then(x => ({ name: x.type, ...x })), 1)));
    }

    async createEntity(_ownerId: string, _entity: TaskCreateRequest): Promise<NamedTaskResponse> {
        throw new Error('Not implemented');
    }

    async setEntityState(_entity: any, _state: string): Promise<any> {
        throw new Error('Not implemented');
    }

    async getGridColumns(_ownerId: string): Promise<IKuiTableCol[]> {
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.TASK.COLUMNS');

        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('type', 'TYPE', ICONS.task),
            grid.IdNameTextColumn('user', 'USER', 120),
            grid.ComboColumn('state', 'STATE', EnumToComboValues(this.admin.i18n, 'TASKS.STATE', this.states, []), 80),
        ];
        columns.push(grid.TimeAgoColumn('date.updated', 'MODIFIED'));
        return columns;
    }

    getEditorSections(ownerId: string, _entity: any): Promise<SectionHandlerGroup<NamedTaskResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new TaskDetailsSectionHandler(this.admin, ownerId, false),
            ],
        }]);
    }

    async getCreationSections(_ownerId: string): Promise<{ entityType: string, entity: any, sections: FormSectionHandler<any, any>[] }> {
        return null;
    }

}













